import { isAfter } from 'date-fns'

export const isDateMoreThan5Years = (date?: Date) => {
  if (date === undefined) {
    return false
  }

  const futureDate = new Date()
  futureDate.setFullYear(futureDate.getFullYear() + 5)
  return isAfter(date, futureDate)
}

export const isDateLessThan5Years = (date?: Date) => {
  if (date === undefined) {
    return false
  }

  return isDateMoreThan5Years(date) === false && date.getTime() > Date.now()
}

export const isPast = (date: Date) => {
  return date.getTime() < Date.now()
}
